import "tom-select/dist/css/tom-select.css";
import "./css/main.css";
import FormFlowManager from "./js/_form-flow-manager";

document.addEventListener("DOMContentLoaded", () => {
  new FormFlowManager();
});
